import { formatNumber, formatVolume } from "../eventStats/utils";
import React from "react";
import { Col, Row } from "antd";
import { StatTile } from "@dowty/ui";

export type StatItem = {
    key: string;
    title: string;
    value: number;
    suffix?: string;
    precision?: number;
};

type SummaryStatsGridProps = {
    items: StatItem[];
};

const SummaryStatsGrid: React.FC<SummaryStatsGridProps> = ({ items }) => (
    <Row gutter={[0, 16]} className="drink-stats-kpi-grid">
        {items.map((item) => (
            <Col flex="1 1 220px" key={item.key}>
                <StatTile label={item.title} value={item.suffix === "ml" ? formatVolume(item.value) : formatNumber(item.value, item.precision)} unit={item.suffix === "ml" ? undefined : item.suffix} />
            </Col>
        ))}
    </Row>
);

export default SummaryStatsGrid;
